const clientValidateOTPMapper = (response) => {
    if (response && response.data.msg)
        return { message: response.data.msg, clientValidated: true };
    return {
        message: "",
        clientValidated: false,
    };
};
export default clientValidateOTPMapper;
